import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Direction } from '../../types/direction';

const rotateMapping = {
  down: 'rotate(180deg)',
  up: 'rotate(0deg)',
  left: 'rotate(270deg)',
  right: 'rotate(90deg)',
};

@Component({
    selector: 'app-icon-caret-v2',
    templateUrl: './icon-caret-v2.component.html',
    styleUrls: ['./icon-caret-v2.component.scss'],
    standalone: false
})
export class IconCaretV2Component implements OnChanges {
  @Input() color = '#011835';
  @Input() width = '16';
  @Input() height = '16';
  @Input() direction: Direction = 'right';
  rotate: string = this.getRotateMapping('right');

  getRotateMapping(direction: string) {
    return rotateMapping[direction] || rotateMapping.down;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.direction) {
      this.rotate = this.getRotateMapping(changes.direction.currentValue);
    }
  }
}
